// ============================================================================
// Indemnisation - Page Création (Événements clients)
// Route : /indemnisation/creation
// Contenu : déclaration d'événement client (DemandeAssistanceForm en mode
//           embarqué : l'agent choisit le client, puis la souscription active)
// ============================================================================

import { Typography } from '@mui/material';
import DemandeAssistanceForm from './DemandeAssistanceForm';

const IndemnisationCreationPage = () => (
  <div className="tab safeCarePage">
    <Typography align="center" className="formTitle">
      <b>{window.location.pathname}</b>
    </Typography>
    <DemandeAssistanceForm embedded />
  </div>
);

export default IndemnisationCreationPage;
